import React from "react"
import { TranslationText } from "components/TextTranslationContainer";
import { PriceRender } from "components/DisplayPrice";
import { SplitBillTypeKeys } from ".";

export const RenderSplitBillInfo = ({ title, value, isPrice, isText }) => {
  return (
    <div className="flex justify-between items-center">
      <TranslationText
        text={title}
        className="text-16x font-semibold text-dark-blue-900"
      />
      {isPrice && (
        <PriceRender
          price={Number(value || 0)}
          className="text-16x font-semibold text-dark-blue-900 mt-0 leading-none"
        />
      )}
      {isText && (
        <TranslationText
          text={value || ""}
          className="text-16x font-semibold text-dark-blue-900 mt-0"
        />
      )}
    </div>
  );
};

const SplitSummary = ({ splitOption, selectedTip, taxRate, dineInServiceFee, previousTipAmount }) => {
  const tipAmount = (selectedTip?.tipAmount ?? 0) + (previousTipAmount ?? 0)
  return (
    <>
      {splitOption?.already &&
        splitOption?.type === SplitBillTypeKeys.DIVIDE_EQUALLY && (
          <RenderSplitBillInfo
            title="Pending to Pay"
            value={
              splitOption.splittedforPeople
                ? parseInt(splitOption.peopleAtTable) -
                  parseInt(splitOption.splittedforPeople)
                : 0
            }
            isText
          />
        )}

      {
        splitOption?.type === SplitBillTypeKeys.SELECTED_ITEMS && (
            <>
            <RenderSplitBillInfo
            title="Service Fee"
            value={ dineInServiceFee?.calculatedAmount  || 0}
            isPrice
          />
          <RenderSplitBillInfo
            title="Value Added Tax"
            value={`${taxRate || 0}%`}
            isText
          />
          {tipAmount > 0 && <RenderSplitBillInfo
            title="Tip Amount"
            value={tipAmount || 0}
            isPrice
          />}
          </>
        )
      }  

      <RenderSplitBillInfo
        title="Your Share"
        value={splitOption?.amount }
        isPrice
      />
      <RenderSplitBillInfo
        title="Remaining Amount"
        value={splitOption?.remainingAmount || 0}
        isPrice
      />
    </>
  );
};

export default SplitSummary;
